module.exports = __webpack_public_path__ + "static/media/promotional_8.99aa556e.png";